import { type } from './base.js';

export const defaultDispatcher = (...objs) => objs.map(type);

export function initMulti(name, dispatcher = defaultDispatcher) {
  const handlers = {};
  let defaultMethod = (types) => {
    throw new Error(`Didn't found handler in multimethod ${name} for types: "${types}"`);
  };

  function getType(types) {
    if (typeof types === 'string') return types;
    return types.join('-');
  }

  function call(...args) {
    const types = getType(dispatcher(...args));

    if (handlers.hasOwnProperty(types)) return handlers[types](...args);
    return defaultMethod(types, ...args);
  }

  call.addMethod = function (actionTypes, method) {
    handlers[getType(actionTypes)] = method;
  };

  call.defaultMethod = function (method) {
    defaultMethod = (_, ...args) => method(...args);
  };

  return call;
}
